// Modules
import { Button as ButtonComponent } from "antd";

// Styles
import styles from "components/atoms/Button/button.module.css";

export type ButtonType = "active" | "disabled" | "activeLong" | "disabledLong";
export type BackgroundType = "violet" | "yellow" | "green" | "red" | "white" | "redWhite";

type ButtonProps = {
	label: string | JSX.Element;
	id?: string;
	type?: ButtonType;
	background?: BackgroundType;
	onClick?: () => void;
};

const Button = ({ label, id, type = "active", background = "violet", onClick }: ButtonProps) => {
	const btnClass = styles[`button_${type}_${background}`];

	return (
		<ButtonComponent id={id} data-testid={id || label} onClick={onClick} className={btnClass}>
			{label}
		</ButtonComponent>
	);
};

export default Button;
